import { useQuery } from 'react-query';

import {
  postInitiateRecoveryFactorScaOperationStatus,
  type PostRecoveryFactorScaOperationStatusInput,
} from 'modules/members/api/postInitiateRecoveryFactorScaOperationStatus';

export const useInitiateRecoveryFactorScaOperationStatusQuery = ({
  authenticationMethod,
  companyId,
  procedureId,
  shareMethod,
  userId,
}: Omit<PostRecoveryFactorScaOperationStatusInput, 'procedureId'> & {
  procedureId?: string;
}) => {
  const { data, error } = useQuery(
    ['initiateRecoveryFactorScaOperationStatus', procedureId],
    () =>
      postInitiateRecoveryFactorScaOperationStatus({
        authenticationMethod,
        companyId,
        procedureId: procedureId as string,
        shareMethod,
        userId,
      }),
    {
      enabled: !!procedureId,
      refetchInterval: (response) => {
        // Stop polling if procedure is completed
        if (
          response?.procedureStatus === 'approved' ||
          response?.procedureStatus === 'rejected' ||
          response?.procedureStatus === 'timeout'
        ) {
          return false;
        }
        // Only poll for 'sca' authentication method
        return authenticationMethod === 'sca' ? 2500 : false;
      },
      refetchOnWindowFocus: false,
    },
  );

  let procedureFailedReason: 'rejected' | 'timeout' | 'unknown' | undefined;

  if (data?.procedureStatus === 'rejected') {
    procedureFailedReason = 'rejected';
  } else if (data?.procedureStatus === 'timeout') {
    procedureFailedReason = 'timeout';
  } else if (error) {
    procedureFailedReason = 'unknown';
  } else {
    procedureFailedReason = undefined;
  }

  return {
    procedureFailedReason,
    initiateRecoveryFactorOutput:
      data?.procedureStatus === 'approved' ? data.output : undefined,
  };
};
